'use client';

/* eslint-disable react/jsx-props-no-spreading */
import { Popover, useIsInsideModal } from '@coop/cds-components';
import classNames from 'classnames';
import * as React from 'react';
import { Select as AriaSelect } from 'react-aria-components';

import styles from './Select.module.scss';

const Select = React.forwardRef<
    HTMLDivElement,
    Omit<React.ComponentPropsWithoutRef<typeof AriaSelect>, 'children'> & {
        'aria-label': string;
        triggerSlot: React.ReactNode;
        renderSelectedText?: (selectedText: string | null) => React.ReactNode;
        popoverProps?: React.ComponentProps<typeof Popover>;
        children: React.ComponentProps<typeof Popover>['children'];
    }
>(({ triggerSlot, ...props }, forwardedRef) => {
    const isInsideModal = useIsInsideModal();

    return (
        <AriaSelect
            ref={forwardedRef}
            {...props}
            className={classNames(props.className, styles.Container)}
        >
            {triggerSlot}
            <Popover
                {...props.popoverProps}
                className={props.popoverProps?.className}
                isNonModal={isInsideModal} // if isNonModal is false and Select is in another modal, in Firefox the popover opens and closes immediately
            >
                {props.children}
            </Popover>
        </AriaSelect>
    );
});

export default Select;
